import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import axios from 'axios';

import App from './App';
import store from './Redux/store';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'font-awesome/css/font-awesome.min.css';
import 'weather-icons/css/weather-icons.css';
import 'prismjs/themes/prism.css';
import '../src/assets/scss/styles.scss';

const redirectMalformedUrlTo404 = () => {
  const { pathname, search, hash } = window.location;

  try {
    decodeURI(pathname);
  } catch (error) {
    const originalPath = `${pathname}${search}${hash}`;
    const encodedOriginalPath = encodeURIComponent(originalPath);

    window.location.replace(`/404?from=${encodedOriginalPath}`);
  }
};

redirectMalformedUrlTo404();

// Admin API requests use the authentication cookie.
axios.defaults.withCredentials = true;

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
